const SKILL_TEMPLATE =
    '<label style="border: 1px solid lightgrey; margin: 10px; padding: 5px; display: inline-block;">' +
    '  <span>' +
    '    <div style="text-align: center;">CAMPAIGN_STATUS_NAME</div>' +
    '    <div>' +
    '      <input type="checkbox" CHECKED/>' +
    '      <span><i class="material-icons">STATUS</i></span>' +
    '    </div>' +
    '  </span>' +
    '</label>';

const FILTER_TITLE =
    '<div style="text-align: center; background: lightgray; width: 100%; display: block; border-bottom: 1px solid grey;">' +
    '<b>TITLE_NAME</b>' +
    '</div>';

export class CampaignStatusFilter {
    init(params) {
        this.filterChangedCallback = params.filterChangedCallback;
        this.model = {
            text_format: true,
            check_circle_outline: true,
            perm_identity: true,
            pause_circle_outline: true
        };
        this.filterChangedCallback();

    }

    getGui() {
        let eGui = document.createElement('div');
        let eInstructions = document.createElement('div');
        eInstructions.innerHTML = FILTER_TITLE.replace('TITLE_NAME', 'Select Campaign Status');
        eGui.appendChild(eInstructions);

        let that = this;
        ['text_format', 'check_circle_outline', 'perm_identity' , 'pause_circle_outline'].forEach(function(skill, index) {
            let skillName = ['Active', 'Historic', 'Member' , 'Paused'][index];
            let eSpan = document.createElement('span');
            let html;
            if(that.model[skill] === true){
               html = SKILL_TEMPLATE.replace("CHECKED", "checked").replace("CAMPAIGN_STATUS_NAME", skillName).replace("STATUS", skill);
            }else{
                html = SKILL_TEMPLATE.replace("CHECKED", '').replace("CAMPAIGN_STATUS_NAME", skillName).replace("STATUS", skill);
            }
            // console.log(that.model)
            eSpan.innerHTML = html;

            let eCheckbox = eSpan.querySelector('input');
            eCheckbox.addEventListener('click', function() {
                that.model[skill] = eCheckbox.checked;
                that.filterChangedCallback();
            });

            eGui.appendChild(eSpan);
        });

        return eGui;
    }

    doesFilterPass(params) {

        let rowSkills = params.data.skills;
        let model = this.model;
        let passed = true;

        ['text_format', 'check_circle_outline', 'perm_identity' , 'pause_circle_outline'].forEach(function(skill) {
            if (model[skill]) {
                if (!rowSkills[skill]) {
                    passed = false;
                }
            }
        });

        return passed;
    }

    isFilterActive() {
        let model = this.model;
        let somethingSelected = model.text_format || model.check_circle_outline || model.perm_identity;
        return somethingSelected;
    }

    getModel() {
        return {campaign_status: this.model};
    }

    setModel(model) {
        this.filter = model ? model.filter : '';
    }
}